import styled from "styled-components";

export const MatrixPageControllerContent = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  column-gap: 0.75rem;
`;

export const MatrixPageControllerSubContent = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  column-gap: 0.75rem;
`;

export const MatrixPageStepperLabel = styled.div`
  text-align: center;
  font-size: 0.675rem;
  white-space: pre-wrap;
`;
